import TextareaAutosize from "react-textarea-autosize";
import styled from "@emotion/styled";
import { media } from "../Window/themes";
const Message = {
    IFrameWrapper: styled.div `
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%;
  `,
    Text: styled.div `
    position: relative;
    margin: 0;
    text-align: left;
    white-space: pre-line;
    span {
      color: ${({ status, theme, }) => {
        switch (status) {
            case "sending":
                return theme === null || theme === void 0 ? void 0 : theme.color.textMuted;
            case "failed":
                return "#F04747";
            default:
                return "inherit";
        }
    }};
    }

    & > a {
      color: ${({ theme }) => theme.color.anchor};
      text-decoration: none;
    }
    & > a:hover,
    & > a:focus,
    & > a:visited {
      color: ${({ theme }) => theme.color.anchorMuted};
    }
  `,
    IndentedIframe: styled.iframe `
    border-left: 0.2rem solid ${({ theme }) => theme.color.backgroundAccent};
    padding-left: 1rem;
    margin: 0.5rem 0;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  `,
    TextSize: styled.span `
    font-size: ${({ isJustEmoji }) => isJustEmoji ? "1.8em" : "inherit"};
  `,
    TextAreaWrapper: styled.div `
    display: flex;
    flex-direction: column;
  `,
    Textarea: styled(TextareaAutosize) `
    padding: 1em 2em;
    overflow: hidden;
    border: 2px solid ${({ theme }) => theme.color.backgroundAccent};
    height: unset;
    min-height: 3em;
    border-radius: 0.7em;
    color: ${({ theme }) => theme.color.text};
    background-color: ${({ theme }) => theme.color.inputBackground};
    caret-color: ${({ theme }) => theme.color.textMuted};
    resize: none;
    &:focus {
      outline: none;
    }
    ::placeholder {
      color: ${({ theme }) => theme.color.textMuted};
    }
    ${media.medium} {
      height: 42px;
    }
  `,
    ButtonGroup: styled.div `
    align-self: end;
    margin-top: 0.5rem;
    display: flex;
    flex-direction: row;
  `,
    SaveButton: styled.button `
    margin-right: 0.5rem;
    color: ${({ theme }) => theme.color.backgroundBrand};
    border-color: ${({ theme }) => theme.color.backgroundBrand};
    cursor: pointer;
    background-color: transparent;
    background-image: none;
    border-color: #de4e46;
    display: inline-block;
    font-weight: 200;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid;
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem !important;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    &:hover {
      color: ${({ theme }) => theme.color.background};
      background-color: ${({ theme }) => theme.color.backgroundBrand};
    }
    ${media.medium} {
      font-weight: 200 !important;
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
  `,
    Button: styled.button `
    color: ${({ theme }) => theme.color.cancelButtonColor};
    border-color: ${({ theme }) => theme.color.cancelButtonColor};
    cursor: pointer;
    background-color: ${({ theme }) => theme.color.cancelButtonBgColor};
    background-image: none;
    display: inline-block;
    font-weight: 200;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid;
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem !important;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    &:hover {
      border-color: ${({ theme }) => theme.color.cancelButtonHover};
      background-color: ${({ theme }) => theme.color.cancelButtonHover};
    }
    ${media.medium} {
      font-weight: 200 !important;
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
  `,
    Span: styled.span `
    font-size: 0.8rem;
    font-style: italic;
    color: ${({ theme }) => theme.color.textMuted}!important;
  `,
    Anchor: styled.a `
    color: ${({ theme }) => theme.color.anchor};
    text-decoration: none;
    &:hover,
    &:visited {
      color: ${({ theme }) => theme.color.anchorMuted};
      text-decoration: underline;
    }
  `,
};
export default Message;
//# sourceMappingURL=AugmentedMessage.styled.js.map